import { render, staticRenderFns } from "./SerialPopup.vue?vue&type=template&id=d564ab9a"
import script from "./SerialPopup.vue?vue&type=script&lang=js"
export * from "./SerialPopup.vue?vue&type=script&lang=js"
import style0 from "./SerialPopup.vue?vue&type=style&index=0&id=d564ab9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports